import axios from 'axios'
import { useCallback, useEffect, useState } from 'react'

import { getUser } from 'pared/utils/user'

interface ICorrectionHistoryItem {
  date: string // in YYYY-MM-DD format
  locationId: number
  locationName: string
  correctedNetSales: number
  correctedCheckCount?: number
  overwrittenByNboDate?: string // in YYYY-MM-DD format
}

const useCorrectionHistory = () => {
  const [data, setData] = useState<ICorrectionHistoryItem[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [refreshKey, setRefreshKey] = useState(0)

  const refetch = useCallback(() => {
    setRefreshKey((prev) => prev + 1)
  }, [])

  useEffect(() => {
    const fetchCorrectionHistory = async () => {
      setIsLoading(true)
      setError(null)

      try {
        const user = getUser()

        const response = await axios.post(
          `${process.env.REACT_APP_BE_BASE_URL}/correct_data_manually`,
          {
            userId: user.userId,
            userJwt: user.jwt,
            requestType: 'LIST_CORRECTION_HISTORY',
          },
          {
            timeout: 60000,
          },
        )

        setData(response.data || [])
      } catch (err: any) {
        console.error('Error fetching correction history:', err)
        setError(err.message || 'Failed to fetch correction history')
      } finally {
        setIsLoading(false)
      }
    }

    fetchCorrectionHistory()
  }, [refreshKey])

  return { data, isLoading, error, refetch }
}

export default useCorrectionHistory
